import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { AuthService } from './demo/service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor(
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.authService.startTokenExpirationWatcher(60);
    this.listenToAuthStorageChanges();


    this.primengConfig.ripple = true;
    this.primengConfig.setTranslation({
      accept: 'Aceptar',
      reject: 'Cancelar',
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      today: 'Hoy',
      clear: 'Borrar',
      weekHeader: 'Sem'
    });
  }

  /**
   * @author Ministerio de Cultura
   * @createdate 2026-02-06
   * @description
   * Detecta cambios en el almacenamiento local relacionados con la autenticación (token) y recarga la página si se detecta un cambio.
   * Esto es útil para mantener la sesión sincronizada en diferentes pestañas del navegador.
   * Si el token se elimina o se actualiza en una pestaña, las otras pestañas se recargarán para reflejar el cambio de estado de autenticación.
   */
  listenToAuthStorageChanges() {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'token') {
        window.location.reload();
        return;
      }

      if ((event.key === null && event.oldValue === null && event.newValue === null)) {
        this.router.navigate(['/']).then(() => {
          window.location.reload();
        });
      }
    });
  }

}
